const HIDDEN_MONITORING_PERMISSIONS = new Set([
  'monitoring-configure',
  'monitoring-manual-entry',
  'monitoring-connect-iot'
]);

export function filterTeamPermissions(
  aPermissions,
  bHasIndicatorModule,
  bHasRiskAndNonConformitesModule
) {
  return (aPermissions || [])
    .filter(parent => {
      if (!bHasIndicatorModule && parent.perm_cslug === 'indicator') return false;
      if (
        !bHasRiskAndNonConformitesModule &&
        ['risk-management', 'non-conformities'].includes(parent.perm_cslug)
      ) {
        return false;
      }
      return true;
    })
    .map(parent => {
      let aChildren = parent.children_permissions || [];

      if (parent.perm_cslug === 'monitoring') {
        aChildren = aChildren.filter(
          child => !HIDDEN_MONITORING_PERMISSIONS.has(child.perm_cslug)
        );
      }

      if (parent.perm_cslug === 'operational-panel') {
        aChildren = aChildren.filter(child => child.perm_cslug !== 'create-edit-project');
      }

      if (aChildren === parent.children_permissions) return parent;

      return {
        ...parent,
        children_permissions: aChildren
      };
    });
}
